import React from "react";
import "./EarthFilling.css";

const EarthFilling = () => {
  return (
    <div>
      <h1>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint,
        voluptas?
      </h1>
    </div>
  );
};

export default EarthFilling;
